
















import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class ProgramPill extends Vue {
  @Prop({ type: String, required: true }) to!: string;
  @Prop({ type: String, default: "" }) tag!: string;
  @Prop({ type: String, default: "" }) title!: string;
  @Prop({ type: String, default: "" }) description!: string;
  @Prop({ type: String, default: "" }) goLabel!: string;
}
